import { createSignal } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';
import { useCallback } from 'react';

interface IsAutoSkipEnabledProps {
    contentId: string;
}

const isAutoSkipEnabledId = createSignal<string | null>(null);

const disableAutoSkip = () => isAutoSkipEnabledId.set(null);

const enableAutoSkipById = (contentId: string) => isAutoSkipEnabledId.set(contentId);

export const useIsAutoSkipEnabled = ({ contentId }: IsAutoSkipEnabledProps) => {
    const isAutoSkipEnabledIdsVar = useSignal(isAutoSkipEnabledId);

    const isAutoSkipEnabled = isAutoSkipEnabledIdsVar === contentId;

    const enableAutoSkip = useCallback(() => {
        enableAutoSkipById(contentId);
    }, [contentId]);

    return {
        isAutoSkipEnabled,
        enableAutoSkip,
        disableAutoSkip,
    };
};
